export default "__VITE_ASSET__Tl0huvA___"